/* ─────────────────────────────────────────────────────────────────────────
   codeEditorShared.js
   Tema, dil algılama ve PHP IntelliSense/formatter için paylaşılan
   sabitler ve yardımcı fonksiyonlar.
   FlowChartCodeEditorPanel ve FloatingCodeEditor tarafından kullanılır.
───────────────────────────────────────────────────────────────────────── */

/* ── Cursor / GitHub Dark Monaco teması ── */
export const CURSOR_DARK_THEME = {
  base: 'vs-dark',
  inherit: true,
  rules: [
    { token: 'comment',                foreground: '6a737d', fontStyle: 'italic' },
    { token: 'comment.line',           foreground: '6a737d', fontStyle: 'italic' },
    { token: 'comment.block',          foreground: '6a737d', fontStyle: 'italic' },
    { token: 'keyword',                foreground: 'ff6b8a' },
    { token: 'keyword.control',        foreground: 'ff6b8a' },
    { token: 'keyword.operator',       foreground: 'ff6b8a' },
    { token: 'storage',                foreground: 'ff6b8a' },
    { token: 'string',                 foreground: '98e068' },
    { token: 'string.double',          foreground: '98e068' },
    { token: 'string.single',          foreground: '98e068' },
    { token: 'string.heredoc',         foreground: '98e068' },
    { token: 'string.escape',          foreground: '56d6f5' },
    { token: 'string.quoted',          foreground: '98e068' },
    { token: 'string.template',        foreground: '98e068' },
    { token: 'number',                 foreground: 'ffad5c' },
    { token: 'number.hex',             foreground: 'ffad5c' },
    { token: 'constant.numeric',       foreground: 'ffad5c' },
    { token: 'constant.language',      foreground: 'ffad5c', fontStyle: 'italic' },
    { token: 'constant',               foreground: 'ffad5c' },
    { token: 'variable.php',           foreground: 'f8c555' },
    { token: 'variable',               foreground: 'e8ecf1' },
    { token: 'variable.parameter',     foreground: 'f8c555' },
    { token: 'variable.other',         foreground: 'e8ecf1' },
    { token: 'entity.name.function',   foreground: 'b98eff' },
    { token: 'support.function',       foreground: '56d6f5' },
    { token: 'entity.name.class',      foreground: 'ffcc66' },
    { token: 'entity.name.type',       foreground: 'ffcc66' },
    { token: 'support.class',          foreground: 'ffcc66' },
    { token: 'type',                   foreground: 'ffcc66' },
    { token: 'operator',               foreground: 'ff6b8a' },
    { token: 'delimiter',              foreground: 'e0e6ed' },
    { token: 'delimiter.bracket',      foreground: 'e0e6ed' },
    { token: 'metatag',                foreground: '5af78e', fontStyle: 'bold' },
    { token: 'tag',                    foreground: '5af78e' },
    { token: 'tag.id',                 foreground: '5af78e' },
    { token: 'attribute.name',         foreground: 'ffcc66' },
    { token: 'attribute.value',        foreground: '98e068' },
    { token: 'regexp',                 foreground: '98e068' },
    { token: 'namespace',              foreground: 'ffcc66' },
    { token: 'annotation',             foreground: 'b98eff' },
    { token: 'identifier',             foreground: 'e8ecf1' },
    { token: '',                        foreground: 'e8ecf1' },
  ],
  colors: {
    'editor.background':                    '#0a0e14',
    'editor.foreground':                    '#e8ecf1',
    'editorGutter.background':              '#0a0e14',
    'editorLineNumber.foreground':          '#3d4455',
    'editorLineNumber.activeForeground':    '#e8ecf1',
    'editorCursor.foreground':              '#56d6f5',
    'editorCursor.background':              '#0a0e14',
    'editor.selectionBackground':           '#1a3a5c',
    'editor.inactiveSelectionBackground':   '#1a3a5c55',
    'editor.selectionHighlightBackground':  '#1a3a5c35',
    'editor.lineHighlightBackground':       '#0f1923',
    'editor.lineHighlightBorder':           '#16202e',
    'editorWhitespace.foreground':          '#1c2432',
    'editorIndentGuide.background1':        '#1c2432',
    'editorIndentGuide.activeBackground1':  '#3d4455',
    'editor.findMatchBackground':           '#ffad5c55',
    'editor.findMatchBorder':               '#ffad5c',
    'editor.findMatchHighlightBackground':  '#ffad5c25',
    'editor.wordHighlightBackground':       '#1f6feb30',
    'editor.wordHighlightStrongBackground': '#1f6feb50',
    'editorWidget.background':              '#0f1923',
    'editorWidget.border':                  '#1c2432',
    'editorWidget.foreground':              '#e8ecf1',
    'editorSuggestWidget.background':       '#0f1923',
    'editorSuggestWidget.border':           '#1c2432',
    'editorSuggestWidget.foreground':       '#e8ecf1',
    'editorSuggestWidget.selectedBackground': '#1f6feb40',
    'editorSuggestWidget.highlightForeground': '#56d6f5',
    'editorHoverWidget.background':         '#0f1923',
    'editorHoverWidget.border':             '#1c2432',
    'editorHoverWidget.foreground':         '#e8ecf1',
    'scrollbarSlider.background':           '#3d445540',
    'scrollbarSlider.hoverBackground':      '#3d445570',
    'scrollbarSlider.activeBackground':     '#3d445590',
    'minimap.background':                   '#0a0e14',
    'minimap.selectionHighlight':           '#1a3a5c',
    'editorBracketMatch.background':        '#1f6feb30',
    'editorBracketMatch.border':            '#56d6f5',
    'editorOverviewRuler.border':           '#16202e',
    'diffEditor.insertedTextBackground':    '#5af78e22',
    'diffEditor.removedTextBackground':     '#ff6b8a22',
    'editorError.foreground':               '#0a0e14',
    'editorError.border':                   '#0a0e14',
    'editorWarning.foreground':             '#0a0e14',
    'editorWarning.border':                 '#0a0e14',
    'editorInfo.foreground':                '#0a0e14',
    'editorInfo.border':                    '#0a0e14',
  },
};

/* ── Uzantı → Monaco dil ID ── */
export const EXT_TO_LANG = {
  php: 'php', js: 'javascript', jsx: 'javascript',
  ts: 'typescript', tsx: 'typescript',
  html: 'html', htm: 'html',
  css: 'css', scss: 'scss', less: 'less',
  json: 'json', xml: 'xml', sql: 'sql',
  sh: 'shell', bash: 'shell',
  py: 'python', rb: 'ruby',
  yml: 'yaml', yaml: 'yaml', md: 'markdown',
};

export const LANG_STYLE = {
  php:        { color: '#a78bfa', bg: '#7c3aed18', border: '#7c3aed35' },
  javascript: { color: '#fbbf24', bg: '#f59e0b18', border: '#f59e0b35' },
  typescript: { color: '#60a5fa', bg: '#3b82f618', border: '#3b82f635' },
  html:       { color: '#f97316', bg: '#ea580c18', border: '#ea580c35' },
  css:        { color: '#34d399', bg: '#10b98118', border: '#10b98135' },
  scss:       { color: '#f472b6', bg: '#ec489918', border: '#ec489935' },
  json:       { color: '#a3e635', bg: '#84cc1618', border: '#84cc1635' },
  sql:        { color: '#38bdf8', bg: '#0ea5e918', border: '#0ea5e935' },
  python:     { color: '#fbbf24', bg: '#f59e0b18', border: '#f59e0b35' },
  shell:      { color: '#4ade80', bg: '#22c55e18', border: '#22c55e35' },
  xml:        { color: '#fb923c', bg: '#f9731618', border: '#f9731635' },
};

export function detectLang(filename) {
  if (!filename) return 'php';
  const ext = (filename.split('.').pop() || '').toLowerCase();
  return EXT_TO_LANG[ext] || 'php';
}

/* ── PHP completions ── */
export const PHP_KEYWORDS = [
  'echo', 'print', 'return', 'if', 'else', 'elseif', 'while', 'for', 'foreach', 'do',
  'switch', 'case', 'default', 'break', 'continue', 'function', 'class', 'interface',
  'trait', 'extends', 'implements', 'new', 'null', 'true', 'false', 'try', 'catch',
  'finally', 'throw', 'use', 'namespace', 'public', 'protected', 'private', 'static',
  'abstract', 'final', 'var', 'const', 'array', 'list', 'match', 'fn', 'yield',
  'require', 'include', 'require_once', 'include_once', 'isset', 'unset', 'empty',
  'die', 'exit', 'global', 'self', 'parent', '__construct', '__destruct',
];

export const PHP_SNIPPETS = [
  { label: 'if',       insert: 'if ($1) {\n\t$2\n}',                           doc: 'if block' },
  { label: 'ifelse',   insert: 'if ($1) {\n\t$2\n} else {\n\t$3\n}',           doc: 'if/else block' },
  { label: 'foreach',  insert: 'foreach ($1 as $2) {\n\t$3\n}',                doc: 'foreach loop' },
  { label: 'for',      insert: 'for ($i = 0; $i < $1; $i++) {\n\t$2\n}',       doc: 'for loop' },
  { label: 'while',    insert: 'while ($1) {\n\t$2\n}',                         doc: 'while loop' },
  { label: 'function', insert: 'function $1($2) {\n\t$3\n}',                   doc: 'function declaration' },
  { label: 'class',    insert: 'class $1 {\n\tpublic function __construct($2) {\n\t\t$3\n\t}\n}', doc: 'class' },
  { label: 'try',      insert: 'try {\n\t$1\n} catch (Exception $e) {\n\t$2\n}', doc: 'try/catch' },
  { label: 'switch',   insert: 'switch ($1) {\n\tcase $2:\n\t\t$3\n\t\tbreak;\n\tdefault:\n\t\t$4\n}', doc: 'switch' },
];

export const PHP_FUNCTIONS = [
  'str_replace', 'strlen', 'substr', 'strpos', 'strrpos', 'strtolower', 'strtoupper',
  'trim', 'ltrim', 'rtrim', 'str_pad', 'str_repeat', 'str_split', 'str_word_count',
  'ucfirst', 'lcfirst', 'ucwords', 'nl2br', 'wordwrap',
  'explode', 'implode', 'join', 'array_push', 'array_pop', 'array_shift', 'array_unshift',
  'array_merge', 'array_keys', 'array_values', 'array_map', 'array_filter', 'array_reduce',
  'array_search', 'array_splice', 'array_slice', 'array_chunk', 'array_flip', 'array_unique',
  'array_reverse', 'array_combine', 'array_diff', 'array_intersect', 'in_array', 'count',
  'json_encode', 'json_decode', 'serialize', 'unserialize',
  'sprintf', 'printf', 'number_format', 'round', 'ceil', 'floor', 'abs', 'max', 'min',
  'rand', 'mt_rand', 'sqrt', 'pow',
  'sort', 'rsort', 'asort', 'arsort', 'ksort', 'krsort', 'usort',
  'preg_match', 'preg_match_all', 'preg_replace', 'preg_split', 'preg_quote',
  'date', 'time', 'strtotime', 'mktime', 'microtime',
  'file_get_contents', 'file_put_contents', 'file_exists', 'is_file', 'is_dir',
  'fopen', 'fclose', 'fread', 'fwrite', 'fgets', 'feof',
  'mkdir', 'rmdir', 'unlink', 'rename', 'copy', 'glob',
  'header', 'ob_start', 'ob_get_clean', 'ob_end_clean',
  'session_start', 'session_destroy', 'setcookie',
  'htmlspecialchars', 'htmlentities', 'strip_tags', 'addslashes', 'stripslashes',
  'urlencode', 'urldecode', 'base64_encode', 'base64_decode',
  'md5', 'sha1', 'hash', 'password_hash', 'password_verify',
  'var_dump', 'print_r', 'var_export',
  'class_exists', 'method_exists', 'function_exists',
  'is_array', 'is_string', 'is_int', 'is_float', 'is_numeric', 'is_null', 'is_bool',
  'is_object', 'is_callable', 'intval', 'strval', 'floatval', 'boolval',
  'array_key_exists', 'compact', 'extract',
  'mysqli_connect', 'mysqli_query', 'mysqli_fetch_assoc', 'mysqli_close',
  'PDO', 'PDOException',
];

/* ─────────────────────────────────────────────────────────────────────────
   EK TEMALAR
───────────────────────────────────────────────────────────────────────── */

const mk = (base, bg, fg, kw, str, fn, type, cmt, num, vr, extra = {}) => ({
  base, inherit: true,
  rules: [
    { token: 'comment',              foreground: cmt.replace('#',''), fontStyle: 'italic' },
    { token: 'comment.line',         foreground: cmt.replace('#',''), fontStyle: 'italic' },
    { token: 'comment.block',        foreground: cmt.replace('#',''), fontStyle: 'italic' },
    { token: 'keyword',              foreground: kw.replace('#','') },
    { token: 'keyword.control',      foreground: kw.replace('#','') },
    { token: 'keyword.operator',     foreground: kw.replace('#','') },
    { token: 'storage',              foreground: kw.replace('#','') },
    { token: 'string',               foreground: str.replace('#','') },
    { token: 'string.double',        foreground: str.replace('#','') },
    { token: 'string.single',        foreground: str.replace('#','') },
    { token: 'string.heredoc',       foreground: str.replace('#','') },
    { token: 'string.escape',        foreground: fn.replace('#','') },
    { token: 'number',               foreground: num.replace('#','') },
    { token: 'number.hex',           foreground: num.replace('#','') },
    { token: 'constant.numeric',     foreground: num.replace('#','') },
    { token: 'variable.php',         foreground: vr.replace('#','') },
    { token: 'variable',             foreground: fg.replace('#','') },
    { token: 'entity.name.function', foreground: fn.replace('#','') },
    { token: 'support.function',     foreground: fn.replace('#','') },
    { token: 'entity.name.class',    foreground: type.replace('#','') },
    { token: 'entity.name.type',     foreground: type.replace('#','') },
    { token: 'type',                 foreground: type.replace('#','') },
    { token: 'operator',             foreground: kw.replace('#','') },
    { token: 'delimiter',            foreground: fg.replace('#','') },
    { token: 'metatag',              foreground: fn.replace('#',''), fontStyle: 'bold' },
    { token: '',                     foreground: fg.replace('#','') },
    ...(extra.rules || []),
  ],
  colors: {
    'editor.background':                    bg,
    'editor.foreground':                    fg,
    'editorGutter.background':              bg,
    'editorLineNumber.foreground':          cmt.replace('#',''),
    'editorLineNumber.activeForeground':    fg,
    'editorCursor.foreground':              fn,
    'editor.selectionBackground':           extra.sel || '#264f78',
    'editor.lineHighlightBackground':       extra.lineHl || bg + '33',
    'editorWidget.background':              extra.widget || bg,
    'editorWidget.border':                  cmt,
    'editorSuggestWidget.background':       extra.widget || bg,
    'editorSuggestWidget.selectedBackground': extra.sel || '#264f7860',
    'editorHoverWidget.background':         extra.widget || bg,
    'scrollbarSlider.background':           cmt + '40',
    'minimap.background':                   bg,
    ...(extra.colors || {}),
  },
});

/* Dracula */
const DRACULA_THEME = mk('vs-dark','#282a36','#f8f8f2','#ff79c6','#f1fa8c','#50fa7b','#8be9fd','#6272a4','#bd93f9','#ffb86c',{
  sel:'#44475a',lineHl:'#44475a',widget:'#21222c',
  colors:{'editor.lineHighlightBackground':'#44475a','editorBracketMatch.background':'#6272a455','editorBracketMatch.border':'#6272a4'},
});

/* Monokai */
const MONOKAI_THEME = mk('vs-dark','#272822','#f8f8f2','#f92672','#e6db74','#a6e22e','#66d9ef','#75715e','#ae81ff','#f8f8f2',{
  sel:'#49483e',lineHl:'#3e3d32',widget:'#1e1f1c',
  rules:[{ token:'variable.php', foreground:'f8f8f2' }],
  colors:{'editorBracketMatch.background':'#75715e40','editorBracketMatch.border':'#75715e'},
});

/* One Dark Pro */
const ONE_DARK_THEME = mk('vs-dark','#282c34','#abb2bf','#c678dd','#98c379','#61afef','#e5c07b','#5c6370','#d19a66','#e06c75',{
  sel:'#3e4451',lineHl:'#2c313a',widget:'#21252b',
  colors:{'editorBracketMatch.background':'#528bff40'},
});

/* Material Palenight */
const MATERIAL_PALENIGHT = mk('vs-dark','#292d3e','#eeffff','#c792ea','#c3e88d','#82aaff','#ffcb6b','#676e95','#f78c6c','#eeffff',{
  sel:'#676e9560',lineHl:'#32374d',widget:'#1b1e2b',
  colors:{'editorCursor.foreground':'#ffcc00'},
});

/* Nord */
const NORD_THEME = mk('vs-dark','#2e3440','#d8dee9','#81a1c1','#a3be8c','#88c0d0','#8fbcbb','#4c566a','#b48ead','#d8dee9',{
  sel:'#434c5e',lineHl:'#3b4252',widget:'#3b4252',
  rules:[{ token:'string.escape', foreground:'ebcb8b' }],
  colors:{'editorCursor.foreground':'#88c0d0'},
});

/* Solarized Dark */
const SOLARIZED_DARK = mk('vs-dark','#002b36','#839496','#859900','#2aa198','#268bd2','#b58900','#586e75','#d33682','#839496',{
  sel:'#073642',lineHl:'#073642',widget:'#002b36',
  colors:{'editorLineNumber.foreground':'#586e75','editorCursor.foreground':'#839496'},
});

/* Tomorrow Night */
const TOMORROW_NIGHT = mk('vs-dark','#1d1f21','#c5c8c6','#b294bb','#b5bd68','#81a2be','#de935f','#969896','#de935f','#cc6666',{
  sel:'#373b41',lineHl:'#282a2e',widget:'#282a2e',
});

/* Ayu Dark */
const AYU_DARK = mk('vs-dark','#0d1018','#b3b1ad','#ff8f40','#aad94c','#ffb454','#73d0ff','#626a73','#d2a6ff','#e6b450',{
  sel:'#1a1f29',lineHl:'#131720',widget:'#0d1018',
});

/* Cobalt2 */
const COBALT2 = mk('vs-dark','#193549','#ffffff','#ff9d00','#3ad900','#ffc600','#80fcff','#0088ff','#ff628c','#ffffff',{
  sel:'#0050a4',lineHl:'#0d2a3f',widget:'#193549',
  colors:{'editorCursor.foreground':'#f8f8f0'},
});

/* GitHub Light */
const GITHUB_LIGHT = mk('vs','#ffffff','#24292e','#d73a49','#032f62','#6f42c1','#005cc5','#6a737d','#005cc5','#e36209',{
  sel:'#c8c8fa',lineHl:'#fffbdd',widget:'#f6f8fa',
  colors:{'editorLineNumber.foreground':'#b1bac4','editorCursor.foreground':'#044289'},
});

/* Solarized Light */
const SOLARIZED_LIGHT = mk('vs','#fdf6e3','#657b83','#859900','#2aa198','#268bd2','#b58900','#93a1a1','#d33682','#657b83',{
  sel:'#eee8d5',lineHl:'#eee8d5',widget:'#f9f3e3',
  colors:{'editorLineNumber.foreground':'#93a1a1','editorCursor.foreground':'#657b83'},
});

/* Atom One Light */
const ATOM_ONE_LIGHT = mk('vs','#fafafa','#383a42','#a626a4','#50a14f','#4078f2','#c18401','#a0a1a7','#986801','#e45649',{
  sel:'#e5e5e6',lineHl:'#f0f0f0',widget:'#f0f0f1',
  colors:{'editorCursor.foreground':'#526fff'},
});

export const CUSTOM_THEMES = {
  'dracula':            DRACULA_THEME,
  'monokai':            MONOKAI_THEME,
  'one-dark-pro':       ONE_DARK_THEME,
  'material-palenight': MATERIAL_PALENIGHT,
  'nord':               NORD_THEME,
  'solarized-dark':     SOLARIZED_DARK,
  'tomorrow-night':     TOMORROW_NIGHT,
  'ayu-dark':           AYU_DARK,
  'cobalt2':            COBALT2,
  'github-light':       GITHUB_LIGHT,
  'solarized-light':    SOLARIZED_LIGHT,
  'atom-one-light':     ATOM_ONE_LIGHT,
};

export const EDITOR_THEMES = [
  // Dark
  { id: 'cursor-dark',        name: 'Cursor Dark',        dark: true,  preview: ['#0a0e14','#e8ecf1','#ff6b8a','#98e068'] },
  { id: 'dracula',            name: 'Dracula',            dark: true,  preview: ['#282a36','#f8f8f2','#ff79c6','#f1fa8c'] },
  { id: 'monokai',            name: 'Monokai',            dark: true,  preview: ['#272822','#f8f8f2','#f92672','#e6db74'] },
  { id: 'one-dark-pro',       name: 'One Dark Pro',       dark: true,  preview: ['#282c34','#abb2bf','#c678dd','#98c379'] },
  { id: 'material-palenight', name: 'Material Palenight', dark: true,  preview: ['#292d3e','#eeffff','#c792ea','#c3e88d'] },
  { id: 'nord',               name: 'Nord',               dark: true,  preview: ['#2e3440','#d8dee9','#81a1c1','#a3be8c'] },
  { id: 'solarized-dark',     name: 'Solarized Dark',     dark: true,  preview: ['#002b36','#839496','#859900','#2aa198'] },
  { id: 'tomorrow-night',     name: 'Tomorrow Night',     dark: true,  preview: ['#1d1f21','#c5c8c6','#b294bb','#b5bd68'] },
  { id: 'ayu-dark',           name: 'Ayu Dark',           dark: true,  preview: ['#0d1018','#b3b1ad','#ff8f40','#aad94c'] },
  { id: 'cobalt2',            name: 'Cobalt2',            dark: true,  preview: ['#193549','#ffffff','#ff9d00','#3ad900'] },
  { id: 'vs-dark',            name: 'VS Dark',            dark: true,  preview: ['#1e1e1e','#d4d4d4','#569cd6','#ce9178'] },
  { id: 'hc-black',           name: 'High Contrast',      dark: true,  preview: ['#000000','#ffffff','#d7ba7d','#ce9178'] },
  // Light
  { id: 'github-light',       name: 'GitHub Light',       dark: false, preview: ['#ffffff','#24292e','#d73a49','#032f62'] },
  { id: 'solarized-light',    name: 'Solarized Light',    dark: false, preview: ['#fdf6e3','#657b83','#859900','#2aa198'] },
  { id: 'atom-one-light',     name: 'Atom One Light',     dark: false, preview: ['#fafafa','#383a42','#a626a4','#50a14f'] },
  { id: 'vs',                 name: 'VS Light',           dark: false, preview: ['#ffffff','#000000','#0000ff','#a31515'] },
];

export const EDITOR_FONT_FAMILIES = [
  { id: 'cascadia',    name: 'Cascadia Code',    value: "'Cascadia Code', 'Fira Code', 'JetBrains Mono', Consolas, monospace" },
  { id: 'fira',        name: 'Fira Code',        value: "'Fira Code', 'Cascadia Code', 'JetBrains Mono', Consolas, monospace" },
  { id: 'jetbrains',   name: 'JetBrains Mono',   value: "'JetBrains Mono', 'Fira Code', 'Cascadia Code', Consolas, monospace" },
  { id: 'consolas',    name: 'Consolas',         value: "Consolas, 'Courier New', monospace" },
  { id: 'courier',     name: 'Courier New',      value: "'Courier New', monospace" },
  { id: 'sourcecodepro', name: 'Source Code Pro', value: "'Source Code Pro', Consolas, monospace" },
  { id: 'ubuntumono',  name: 'Ubuntu Mono',      value: "'Ubuntu Mono', Consolas, monospace" },
  { id: 'monaco',      name: 'Monaco',           value: "Monaco, Menlo, monospace" },
];

export const EDITOR_SETTINGS_DEFAULTS = {
  theme:         'cursor-dark',
  fontSize:      13,
  fontFamily:    'cascadia',
  minimap:       true,
  wordWrap:      'on',
  lineNumbers:   'on',
  fontLigatures: true,
  tabSize:       4,
};

export function loadEditorSettings() {
  try {
    const saved = localStorage.getItem('flowchart-editor-settings');
    if (saved) return { ...EDITOR_SETTINGS_DEFAULTS, ...JSON.parse(saved) };
  } catch (_) { /* ignore */ }
  return { ...EDITOR_SETTINGS_DEFAULTS };
}

export function saveEditorSettings(settings) {
  try {
    localStorage.setItem('flowchart-editor-settings', JSON.stringify(settings));
  } catch (_) { /* ignore */ }
}

/* Singleton disposables — sadece bir kez kayıt */
let _phpCompletionDisposable = null;
let _phpFormatterDisposable  = null;
let _phpTokenizerRegistered  = false;
let _phpHoverDisposable      = null;
let _phpSymbolsDisposable    = null;
let _phpValidationAttached   = false;
let _themeRegistered         = false;
const _themeVersion          = 3;

export function registerEditorAssets(monaco) {
  /* 1. Temalar — versiyon değişince yeniden tanımlanır */
  if (!_themeRegistered || _themeRegistered !== _themeVersion) {
    monaco.editor.defineTheme('cursor-dark', CURSOR_DARK_THEME);
    Object.entries(CUSTOM_THEMES).forEach(([id, def]) => {
      try { monaco.editor.defineTheme(id, def); } catch (_) { /* ignore */ }
    });
    _themeRegistered = _themeVersion;
  }

  /* 2. JS/TS diagnostics aç (syntax + semantic) — profesyonel IDE hissi için
        kullanıcı hata yaptığında anında gösterelim. Module resolution kapalı
        (proje contextinde .d.ts yoksa false positive azaltır). */
  if (monaco.languages.typescript) {
    const diag = {
      noSemanticValidation: false,
      noSyntaxValidation: false,
      noSuggestionDiagnostics: false,
      diagnosticCodesToIgnore: [
        2304,  // Cannot find name (module'süz ortamda çok gürültü)
        2339,  // Property does not exist
        2307,  // Cannot find module
        2580,  // Cannot find name 'require' (Node globalleri)
        7016,  // Could not find a declaration file for module
      ],
    };
    const compilerOpts = {
      target:     monaco.languages.typescript.ScriptTarget.ESNext,
      allowNonTsExtensions: true,
      moduleResolution: monaco.languages.typescript.ModuleResolutionKind.NodeJs,
      module:     monaco.languages.typescript.ModuleKind.ESNext,
      jsx:        monaco.languages.typescript.JsxEmit.Preserve,
      allowJs:    true,
      checkJs:    true,
      lib:        ['esnext', 'dom', 'dom.iterable'],
      strict:     false,
      noImplicitAny: false,
    };
    try { monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions(diag); } catch (_) {}
    try { monaco.languages.typescript.typescriptDefaults.setDiagnosticsOptions(diag); } catch (_) {}
    try { monaco.languages.typescript.javascriptDefaults.setCompilerOptions(compilerOpts); } catch (_) {}
    try { monaco.languages.typescript.typescriptDefaults.setCompilerOptions(compilerOpts); } catch (_) {}
    try { monaco.languages.typescript.javascriptDefaults.setEagerModelSync(true); } catch (_) {}
    try { monaco.languages.typescript.typescriptDefaults.setEagerModelSync(true); } catch (_) {}
  }

  /* 2b. JSON diagnostics + format ayarları */
  if (monaco.languages.json && monaco.languages.json.jsonDefaults) {
    try {
      monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
        validate: true,
        allowComments: true,
        trailingCommas: 'warning',
        schemas: [],
        enableSchemaRequest: false,
      });
    } catch (_) {}
    try {
      monaco.languages.json.jsonDefaults.setModeConfiguration({
        documentFormattingEdits: true,
        documentRangeFormattingEdits: true,
        completionItems: true,
        hovers: true,
        documentSymbols: true,
        tokens: true,
        colors: true,
        foldingRanges: true,
        diagnostics: true,
        selectionRanges: true,
      });
    } catch (_) {}
  }

  /* 2c. CSS / SCSS / LESS diagnostics + format */
  if (monaco.languages.css) {
    const cssCfg = {
      validate: true,
      lint: {
        compatibleVendorPrefixes: 'warning',
        vendorPrefix: 'warning',
        duplicateProperties: 'warning',
        emptyRules: 'warning',
        importStatement: 'ignore',
        boxModel: 'ignore',
        universalSelector: 'ignore',
        zeroUnits: 'ignore',
        fontFaceProperties: 'warning',
        hexColorLength: 'error',
        argumentsInColorFunction: 'error',
        unknownProperties: 'warning',
        validProperties: [],
      },
    };
    try { monaco.languages.css.cssDefaults.setOptions(cssCfg); } catch (_) {}
    try { monaco.languages.css.scssDefaults.setOptions(cssCfg); } catch (_) {}
    try { monaco.languages.css.lessDefaults.setOptions(cssCfg); } catch (_) {}
    try {
      const modeCfg = {
        completionItems: true, hovers: true, documentSymbols: true,
        definitions: true, references: true, documentHighlights: true,
        rename: true, colors: true, foldingRanges: true, diagnostics: true,
        selectionRanges: true, documentFormattingEdits: true,
        documentRangeFormattingEdits: true,
      };
      monaco.languages.css.cssDefaults.setModeConfiguration(modeCfg);
      monaco.languages.css.scssDefaults.setModeConfiguration(modeCfg);
      monaco.languages.css.lessDefaults.setModeConfiguration(modeCfg);
    } catch (_) {}
  }

  /* 2d. HTML diagnostics + format */
  if (monaco.languages.html && monaco.languages.html.htmlDefaults) {
    try {
      monaco.languages.html.htmlDefaults.setOptions({
        format: {
          tabSize: 4, insertSpaces: true, wrapLineLength: 120,
          unformatted: 'default"',
          contentUnformatted: 'pre,code,textarea',
          indentInnerHtml: false, preserveNewLines: true,
          maxPreserveNewLines: null, indentHandlebars: false,
          endWithNewline: false, extraLiners: 'head, body, /html',
          wrapAttributes: 'auto',
        },
        suggest: { html5: true },
      });
    } catch (_) {}
    try {
      monaco.languages.html.htmlDefaults.setModeConfiguration({
        completionItems: true, hovers: true, documentSymbols: true,
        links: true, documentHighlights: true, rename: true,
        colors: true, foldingRanges: true, diagnostics: true,
        selectionRanges: true, documentFormattingEdits: true,
        documentRangeFormattingEdits: true,
      });
    } catch (_) {}
  }

  /* 3. PHP özel Monarch tokenizer — syntax renklendirme */
  if (!_phpTokenizerRegistered) {
    _phpTokenizerRegistered = true;
    try {
      monaco.languages.setMonarchTokensProvider('php', {
        defaultToken: '',
        tokenPostfix: '.php',
        ignoreCase: true,
        keywords: PHP_KEYWORDS,
        builtins: PHP_FUNCTIONS,
        tokenizer: {
          root: [
            [/<\?php\b|<\?=?/, { token: 'metatag', next: '@phpCode' }],
            [/[^<]+/, 'text'],
            [/</, 'text'],
          ],
          phpCode: [
            [/\?>/, { token: 'metatag', next: '@pop' }],
            // Comments
            [/\/\/.*$/, 'comment.line'],
            [/#.*$/, 'comment.line'],
            [/\/\*/, { token: 'comment.block', next: '@blockComment' }],
            // Strings
            [/"/, { token: 'string.double', next: '@dstring' }],
            [/'/, { token: 'string.single', next: '@sstring' }],
            // Heredoc (basit)
            [/<<<([a-zA-Z_]\w*)/, { token: 'string.heredoc.delimiter', next: '@heredoc' }],
            // Numbers
            [/\b0x[\da-fA-F]+\b/, 'number.hex'],
            [/\b\d+(\.\d+)?([eE][+-]?\d+)?\b/, 'number'],
            // Variables
            [/\$[a-zA-Z_]\w*/, 'variable.php'],
            // Class/interface/trait names after keywords
            [/(?<=(class|interface|trait|extends|implements|new)\s+)[A-Z]\w*/, 'entity.name.class'],
            // Function calls — identifier followed by (
            [/[a-zA-Z_]\w*(?=\s*\()/, {
              cases: {
                '@keywords': 'keyword',
                '@builtins': 'support.function',
                '@default': 'entity.name.function',
              },
            }],
            // Regular identifiers & keywords
            [/[a-zA-Z_]\w*/, {
              cases: {
                '@keywords': 'keyword',
                '@default': 'identifier',
              },
            }],
            // Brackets & delimiters
            [/[{}()\[\]]/, 'delimiter.bracket'],
            [/[;,]/, 'delimiter'],
            [/\./, 'delimiter'],
            // Operators
            [/->|=>|::|===|!==|==|!=|<=|>=|&&|\|\||\?\?/, 'operator'],
            [/[+\-*\/%=!<>&|^~?:]/, 'operator'],
            // Whitespace
            [/\s+/, ''],
          ],
          blockComment: [
            [/\*\//, { token: 'comment.block', next: '@pop' }],
            [/[^*]+/, 'comment.block'],
            [/\*(?!\/)/, 'comment.block'],
          ],
          dstring: [
            [/\$[a-zA-Z_]\w*/, 'variable.php'],
            [/\\./, 'string.escape'],
            [/[^"\\$]+/, 'string.double'],
            [/"/, { token: 'string.double', next: '@pop' }],
          ],
          sstring: [
            [/\\./, 'string.escape'],
            [/[^'\\]+/, 'string.single'],
            [/'/, { token: 'string.single', next: '@pop' }],
          ],
          heredoc: [
            [/.*$/, 'string.heredoc'],
          ],
        },
      });
    } catch (_) {
      // Tokenizer kayıt hatası — sessizce geç
    }
  }

  /* 4. PHP completion provider — scope-aware akıllı IntelliSense
        - Değişkenleri cursor'un SOLUNDAN toplar (scope farkındalığı)
        - Function parametrelerini ve local variables'ı prioritize eder
        - $this-> ile sınıf üyelerini doğru filtreler
        - docblock desteği */
  if (!_phpCompletionDisposable) {
    _phpCompletionDisposable = monaco.languages.registerCompletionItemProvider('php', {
      triggerCharacters: ['$', '-', '>', ':', '\\', '@', '('],
      provideCompletionItems: (model, position) => {
        const word = model.getWordUntilPosition(position);
        const lineContent = model.getLineContent(position.lineNumber);
        const textBefore = lineContent.substring(0, position.column - 1);

        // FIX: Monaco `$` karakterini "word" saymadığı için range $'ı kapsamıyor
        // ve öneri seçilince `$` siliniyordu. Eğer cursor'dan önce `$` (+ opsiyonel
        // kısmi identifier) varsa range'i $'ı da içerecek şekilde geri al; insertText
        // de `$name` olarak verilir.
        const dollarMatch = textBefore.match(/\$[a-zA-Z_]\w*$/);
        const dollarRange = dollarMatch ? {
          startLineNumber: position.lineNumber,
          endLineNumber:   position.lineNumber,
          startColumn:     position.column - dollarMatch[0].length,
          endColumn:       position.column,
        } : null;

        const range = dollarRange || {
          startLineNumber: position.lineNumber,
          endLineNumber:   position.lineNumber,
          startColumn:     word.startColumn,
          endColumn:       word.endColumn,
        };

        const isAfterArrow = /->\s*\w*$/.test(textBefore);
        const isAfterThis  = /\$this->\s*\w*$/.test(textBefore);
        const isAfterDollar = !!dollarMatch;
        const isAfterDoubleColon = /::\s*\w*$/.test(textBefore);
        const isAfterNew = /\bnew\s+\w*$/.test(textBefore);

        const code = model.getValue();
        const offset = model.getOffsetAt(position);
        const codeBeforeCursor = code.slice(0, offset);
        const codeAfterCursor  = code.slice(offset);

        const seen = new Set();
        const items = [];

        // Cursor'un bulunduğu fonksiyonu tespit et — scope-awareness için
        let scopeText = codeBeforeCursor;
        let scopeStartLine = 1;
        // Bulunduğumuz fonksiyonun başını bul: en son 'function ... {'
        const fnOpenRe = /function\s+[a-zA-Z_]\w*\s*\([^)]*\)\s*\{/g;
        let lastFnOpen = null;
        let fn;
        while ((fn = fnOpenRe.exec(codeBeforeCursor)) !== null) lastFnOpen = fn;
        if (lastFnOpen) {
          // Eğer bu açılışa karşılık gelen kapanış cursor'dan önce geçtiyse fonksiyon dışındayız
          let depth = 0;
          let exitedScope = false;
          for (let k = lastFnOpen.index + lastFnOpen[0].length - 1; k < codeBeforeCursor.length; k++) {
            if (codeBeforeCursor[k] === '{') depth++;
            else if (codeBeforeCursor[k] === '}') { depth--; if (depth === 0) { exitedScope = true; break; } }
          }
          if (!exitedScope) {
            scopeText = codeBeforeCursor.slice(lastFnOpen.index);
            scopeStartLine = (codeBeforeCursor.slice(0, lastFnOpen.index).match(/\n/g) || []).length + 1;
          }
        }

        // ── 1) Mevcut scope'taki $variables — en yüksek öncelik
        const scopeVarRe = /\$([a-zA-Z_]\w*)/g;
        let m;
        while ((m = scopeVarRe.exec(scopeText)) !== null) {
          const v = m[1];
          if (v === 'this') continue;
          const key = '$' + v;
          if (seen.has(key)) continue;
          seen.add(key);
          items.push({
            label: '$' + v,
            kind: monaco.languages.CompletionItemKind.Variable,
            // Range $'ı kapsıyor, bu yüzden insertText'te de $ bulunmalı
            insertText: '$' + v,
            range, sortText: `00_${v}`,
            detail: 'local variable',
          });
        }

        // ── 2) Fonksiyon parametrelerini ayrı detect et
        if (lastFnOpen) {
          const paramMatch = lastFnOpen[0].match(/\(([^)]*)\)/);
          if (paramMatch && paramMatch[1].trim()) {
            const params = paramMatch[1].split(',').map((p) => p.trim()).filter(Boolean);
            params.forEach((p) => {
              const nameMatch = p.match(/\$([a-zA-Z_]\w*)/);
              if (nameMatch) {
                const key = '$' + nameMatch[1];
                if (!seen.has(key)) {
                  seen.add(key);
                  items.push({
                    label: key,
                    kind: monaco.languages.CompletionItemKind.Variable,
                    insertText: key,
                    range, sortText: `00_${nameMatch[1]}`,
                    detail: `parameter of ${lastFnOpen[0].match(/function\s+(\w+)/)?.[1] || 'current fn'}`,
                  });
                }
              }
            });
          }
        }

        // ── 3) Global scope $variables (fonksiyon dışındaysak veya ek bilgi)
        const allVarRe = /\$([a-zA-Z_]\w*)/g;
        while ((m = allVarRe.exec(code)) !== null) {
          const v = m[1];
          if (v === 'this') continue;
          const key = '$' + v;
          if (seen.has(key)) continue;
          seen.add(key);
          items.push({
            label: key,
            kind: monaco.languages.CompletionItemKind.Variable,
            insertText: key,
            range, sortText: `05_${v}`,
            detail: 'global variable',
          });
        }

        // ── 4) User functions (signature dahil)
        const userFnRe = /function\s+([a-zA-Z_]\w*)\s*\(([^)]*)\)/g;
        while ((m = userFnRe.exec(code)) !== null) {
          const fnName = m[1];
          const params = m[2].trim();
          const key = 'fn_' + fnName;
          if (seen.has(key)) continue;
          seen.add(key);
          items.push({
            label: fnName,
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: `${fnName}($0)`,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range, sortText: `02_${fnName}`,
            detail: `function(${params})`,
            documentation: { value: `\`\`\`php\nfunction ${fnName}(${params})\n\`\`\`` },
          });
        }

        // ── 5) Class / interface / trait
        const clsRe = /(?:class|interface|trait)\s+([A-Z]\w*)/g;
        while ((m = clsRe.exec(code)) !== null) {
          const cls = m[1];
          const key = 'cls_' + cls;
          if (seen.has(key)) continue;
          seen.add(key);
          items.push({
            label: cls,
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: cls, range, sortText: `03_${cls}`,
            detail: 'class',
          });
        }

        // ── 6) const / define
        const constRe = /(?:define\s*\(\s*['"]([A-Z_]\w*)['"]\s*,|const\s+([A-Z_]\w*)\s*=)/g;
        while ((m = constRe.exec(code)) !== null) {
          const c = m[1] || m[2];
          if (c && !seen.has('const_' + c)) {
            seen.add('const_' + c);
            items.push({
              label: c,
              kind: monaco.languages.CompletionItemKind.Constant,
              insertText: c, range, sortText: `04_${c}`, detail: 'constant',
            });
          }
        }

        // ── Context override: $this-> → sadece class method + property
        if (isAfterThis || isAfterArrow) {
          const arrowItems = [];
          const methodRe = /(?:public|protected|private)?\s*(?:static\s+)?function\s+([a-zA-Z_]\w*)\s*\(([^)]*)\)/g;
          const propRe = /(?:public|protected|private)\s+(?:static\s+)?\$([a-zA-Z_]\w*)/g;
          while ((m = methodRe.exec(code)) !== null) {
            arrowItems.push({
              label: m[1], kind: monaco.languages.CompletionItemKind.Method,
              insertText: `${m[1]}($0)`,
              insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              range, sortText: `00_${m[1]}`,
              detail: `(${m[2].trim()})`,
            });
          }
          while ((m = propRe.exec(code)) !== null) {
            arrowItems.push({
              label: m[1], kind: monaco.languages.CompletionItemKind.Property,
              insertText: m[1], range, sortText: `00_${m[1]}`, detail: 'property',
            });
          }
          if (arrowItems.length > 0) return { suggestions: arrowItems };
        }

        // ── Context: :: → static members + class keyword
        if (isAfterDoubleColon) {
          const statics = [
            { label: 'class', kind: monaco.languages.CompletionItemKind.Keyword, insertText: 'class', range, detail: '::class' },
          ];
          const sm = /(?:public|protected|private)?\s*static\s+function\s+([a-zA-Z_]\w*)\s*\(([^)]*)\)/g;
          while ((m = sm.exec(code)) !== null) {
            statics.push({
              label: m[1], kind: monaco.languages.CompletionItemKind.Method,
              insertText: `${m[1]}($0)`,
              insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              range, sortText: `00_${m[1]}`, detail: `static (${m[2].trim()})`,
            });
          }
          return { suggestions: statics };
        }

        // ── Context: new X — sadece sınıf isimleri
        if (isAfterNew) {
          const classesOnly = items.filter((it) => it.kind === monaco.languages.CompletionItemKind.Class);
          if (classesOnly.length > 0) return { suggestions: classesOnly };
        }

        return {
          suggestions: [
            ...items,
            ...PHP_SNIPPETS.map((s) => ({
              label: s.label, kind: monaco.languages.CompletionItemKind.Snippet,
              insertText: s.insert,
              insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              documentation: s.doc, range, sortText: `06_${s.label}`, detail: 'snippet',
            })),
            ...PHP_KEYWORDS.map((k) => ({
              label: k, kind: monaco.languages.CompletionItemKind.Keyword,
              insertText: k, range, sortText: `07_${k}`, detail: 'keyword',
            })),
            ...PHP_FUNCTIONS.map((f) => ({
              label: f, kind: monaco.languages.CompletionItemKind.Function,
              insertText: `${f}($0)`,
              insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              range, sortText: `08_${f}`, detail: 'built-in',
              documentation: { value: `[php.net](https://www.php.net/manual/en/function.${f.replace(/_/g, '-')}.php)` },
            })),
          ],
        };
      },
    });
  }

  /* 5. PHP formatter provider — document + range formatter */
  if (!_phpFormatterDisposable) {
    _phpFormatterDisposable = monaco.languages.registerDocumentFormattingEditProvider('php', {
      provideDocumentFormattingEdits(model) {
        return [{ range: model.getFullModelRange(), text: formatPhpCode(model.getValue()) }];
      },
    });
    // Range formatter — seçili alanı formatla
    try {
      monaco.languages.registerDocumentRangeFormattingEditProvider('php', {
        provideDocumentRangeFormattingEdits(model, range) {
          const text = model.getValueInRange(range);
          return [{ range, text: formatPhpCode(text) }];
        },
      });
    } catch (_) { /* ignore */ }
  }

  /* 6. PHP hover provider — built-in fonksiyonlarda dokümantasyon, kullanıcı
        fonksiyonlarında imza bilgisi göster. */
  if (!_phpHoverDisposable) {
    _phpHoverDisposable = monaco.languages.registerHoverProvider('php', {
      provideHover(model, position) {
        const word = model.getWordAtPosition(position);
        if (!word) return null;
        const name = word.word;
        const code = model.getValue();

        // Built-in?
        if (PHP_FUNCTIONS.includes(name)) {
          return {
            contents: [
              { value: `**${name}()** — PHP built-in function` },
              { value: `[php.net dokümantasyonu](https://www.php.net/manual/en/function.${name.replace(/_/g, '-')}.php)` },
            ],
          };
        }
        if (PHP_KEYWORDS.includes(name)) {
          return { contents: [{ value: `**${name}** — PHP keyword` }] };
        }
        // Kullanıcı fonksiyonu
        const fnMatch = new RegExp(`function\\s+${name}\\s*\\(([^)]*)\\)`).exec(code);
        if (fnMatch) {
          return {
            contents: [
              { value: `**function ${name}(${fnMatch[1].trim()})**` },
              { value: 'Kullanıcı tanımlı fonksiyon' },
            ],
          };
        }
        // Değişken
        if (model.getLineContent(position.lineNumber).charAt(position.column - 2) === '$'
            || /\$\w*$/.test(model.getLineContent(position.lineNumber).slice(0, word.startColumn))) {
          return { contents: [{ value: `**$${name}** — değişken` }] };
        }
        return null;
      },
    });
    _phpHoverDisposable = true;
  }

  /* 7. PHP Document symbols (outline panel, breadcrumb) */
  if (!_phpSymbolsDisposable) {
    monaco.languages.registerDocumentSymbolProvider('php', {
      provideDocumentSymbols(model) {
        const code = model.getValue();
        const symbols = [];
        const SymbolKind = monaco.languages.SymbolKind;

        const addSym = (name, detail, kind, startLine, startCol, endLine, endCol) => {
          symbols.push({
            name, detail: detail || '', kind,
            range:          { startLineNumber: startLine, startColumn: startCol, endLineNumber: endLine, endColumn: endCol },
            selectionRange: { startLineNumber: startLine, startColumn: startCol, endLineNumber: startLine, endColumn: startCol + name.length },
            children: [],
          });
        };

        const lines = code.split('\n');
        lines.forEach((lineText, idx) => {
          const lineNum = idx + 1;
          let m;
          m = /^\s*(?:abstract\s+|final\s+)?class\s+([A-Z]\w*)/.exec(lineText);
          if (m) addSym(m[1], 'class', SymbolKind.Class, lineNum, lineText.indexOf(m[1]) + 1, lineNum, lineText.length + 1);
          m = /^\s*interface\s+([A-Z]\w*)/.exec(lineText);
          if (m) addSym(m[1], 'interface', SymbolKind.Interface, lineNum, lineText.indexOf(m[1]) + 1, lineNum, lineText.length + 1);
          m = /^\s*trait\s+([A-Z]\w*)/.exec(lineText);
          if (m) addSym(m[1], 'trait', SymbolKind.Namespace, lineNum, lineText.indexOf(m[1]) + 1, lineNum, lineText.length + 1);
          m = /^\s*(?:public|protected|private|static)?\s*(?:static\s+)?function\s+([a-zA-Z_]\w*)\s*\(([^)]*)\)/.exec(lineText);
          if (m) addSym(m[1], `(${m[2].trim()})`, SymbolKind.Function, lineNum, lineText.indexOf(m[1]) + 1, lineNum, lineText.length + 1);
          m = /^\s*const\s+([A-Z_]\w*)\s*=/.exec(lineText);
          if (m) addSym(m[1], 'constant', SymbolKind.Constant, lineNum, lineText.indexOf(m[1]) + 1, lineNum, lineText.length + 1);
          m = /^\s*define\s*\(\s*['"]([A-Z_]\w*)['"]/.exec(lineText);
          if (m) addSym(m[1], 'constant', SymbolKind.Constant, lineNum, lineText.indexOf(m[1]), lineNum, lineText.length + 1);
        });
        return symbols;
      },
    });
    _phpSymbolsDisposable = true;
  }

  /* 8. Model değişiminde PHP diagnostics otomatik çalışsın
        (clearEditorMarkers per-editor onMount'ta da bağlıyor; bu global da
        yeni model açıldığında çalışır) */
  if (!_phpValidationAttached) {
    _phpValidationAttached = true;
    try {
      monaco.editor.onDidCreateModel((model) => {
        const run = () => {
          if (model.isDisposed?.()) return;
          const lang = model.getLanguageId?.();
          if (lang !== 'php') return;
          try {
            const diags = validatePhpCode(model.getValue());
            monaco.editor.setModelMarkers(model, 'php-lint', diags.map((d) => ({
              severity: d.severity,
              message: d.message,
              startLineNumber: d.startLineNumber,
              startColumn: d.startColumn,
              endLineNumber: d.endLineNumber,
              endColumn: d.endColumn,
              source: 'php-lint',
            })));
          } catch (_) { /* */ }
        };
        run();
        let to = null;
        model.onDidChangeContent(() => {
          if (to) clearTimeout(to);
          to = setTimeout(run, 400);
        });
      });
    } catch (_) { /* monaco.editor.onDidCreateModel yoksa ignore */ }
  }
}

/* ── Editor marker yönetimi ──
   - PHP dosyaları için validatePhpCode ile inline diagnostics üret
   - Diğer diller için Monaco kendi diagnostics'ini (TS/JS/JSON/HTML/CSS) zaten üretir
*/
export function clearEditorMarkers(editor, monaco) {
  const model = editor.getModel();
  if (!model) return;

  const runValidation = () => {
    if (!model || model.isDisposed?.()) return;
    const lang = model.getLanguageId?.() || '';
    if (lang !== 'php') return;
    try {
      const diags = validatePhpCode(model.getValue());
      const markers = diags.map((d) => ({
        severity: d.severity,
        message: d.message,
        startLineNumber: d.startLineNumber,
        startColumn: d.startColumn,
        endLineNumber: d.endLineNumber,
        endColumn: d.endColumn,
        source: 'php-lint',
      }));
      monaco.editor.setModelMarkers(model, 'php-lint', markers);
    } catch (_) { /* sessiz */ }
  };

  // İlk kez hemen, sonra 400ms debounce
  runValidation();
  let t = null;
  model.onDidChangeContent(() => {
    if (t) clearTimeout(t);
    t = setTimeout(runValidation, 400);
  });
  model.onDidChangeLanguage?.(() => runValidation());
}

/* ─────────────────────────────────────────────────────────────────────────
   PROFESSIONAL PHP FORMATTER
   - Tokenizer tabanlı (regex spam yerine durumlu lexer)
   - String / comment / heredoc / nowdoc / <?php tag aware
   - Doğru scope & indent tracking (array, object, function çağrıları)
   - Switch case otomatik indent
   - Operatör boşluklarını stringlerin içine dokunmadan koyar
───────────────────────────────────────────────────────────────────────── */

const PHP_CTRL_KW_RE = /\b(if|elseif|else\s+if|while|for|foreach|switch|return|echo|print|throw|yield|require|require_once|include|include_once|match|fn)\b/;

/**
 * PHP kodunu token'lara ayırır. Her token: { type, value }
 * type: 'code' | 'string' | 'comment_line' | 'comment_block' | 'heredoc' | 'nowdoc' | 'php_tag' | 'text'
 */
function tokenizePhp(code) {
  const tokens = [];
  let i = 0;
  const len = code.length;

  // <?php dışı düz metni de 'text' olarak tutuyoruz (karıştırmamak için)
  let inPhp = false;

  while (i < len) {
    const ch = code[i];
    const next = code[i + 1];

    // <?php veya <?= veya <?
    if (ch === '<' && code[i + 1] === '?') {
      let end = i + 2;
      if (code.slice(end, end + 3).toLowerCase() === 'php') end += 3;
      else if (code[end] === '=') end += 1;
      tokens.push({ type: 'php_tag', value: code.slice(i, end) });
      i = end;
      inPhp = true;
      continue;
    }

    // ?>
    if (ch === '?' && next === '>') {
      tokens.push({ type: 'php_tag', value: '?>' });
      i += 2;
      inPhp = false;
      continue;
    }

    if (!inPhp) {
      // PHP dışı metin — olduğu gibi kalsın
      let end = code.indexOf('<?', i);
      if (end === -1) end = len;
      tokens.push({ type: 'text', value: code.slice(i, end) });
      i = end;
      continue;
    }

    // Line comment
    if (ch === '/' && next === '/') {
      let end = code.indexOf('\n', i);
      if (end === -1) end = len;
      tokens.push({ type: 'comment_line', value: code.slice(i, end) });
      i = end;
      continue;
    }
    if (ch === '#' && next !== '[') {  // #[...] attributes PHP 8
      let end = code.indexOf('\n', i);
      if (end === -1) end = len;
      tokens.push({ type: 'comment_line', value: code.slice(i, end) });
      i = end;
      continue;
    }

    // Block comment /* ... */
    if (ch === '/' && next === '*') {
      const end = code.indexOf('*/', i + 2);
      const stop = end === -1 ? len : end + 2;
      tokens.push({ type: 'comment_block', value: code.slice(i, stop) });
      i = stop;
      continue;
    }

    // Heredoc / Nowdoc: <<<LABEL ... LABEL;
    if (ch === '<' && next === '<' && code[i + 2] === '<') {
      const hdMatch = code.slice(i).match(/^<<<\s*(['"]?)([A-Za-z_]\w*)\1\n/);
      if (hdMatch) {
        const label = hdMatch[2];
        const isNowdoc = hdMatch[1] === "'";
        // LABEL; veya LABEL kapanışı satır başında
        const re = new RegExp(`\\n[ \\t]*${label}\\s*;?`, 'm');
        const rest = code.slice(i + hdMatch[0].length);
        const closeIdx = rest.search(re);
        if (closeIdx !== -1) {
          const closeMatch = rest.match(re);
          const total = hdMatch[0].length + closeIdx + closeMatch[0].length;
          tokens.push({
            type: isNowdoc ? 'nowdoc' : 'heredoc',
            value: code.slice(i, i + total),
          });
          i += total;
          continue;
        }
      }
    }

    // Strings: " ve '
    if (ch === '"' || ch === "'") {
      const quote = ch;
      let j = i + 1;
      while (j < len) {
        if (code[j] === '\\') { j += 2; continue; }
        if (code[j] === quote) { j++; break; }
        j++;
      }
      tokens.push({ type: 'string', value: code.slice(i, j) });
      i = j;
      continue;
    }

    // Kod — sonraki "özel" karakterin bir önceki bayt'ına kadar oku
    let j = i;
    while (j < len) {
      const c = code[j];
      const n = code[j + 1];
      if (c === '/' && (n === '/' || n === '*')) break;
      if (c === '#' && n !== '[') break;
      if (c === '"' || c === "'") break;
      if (c === '<' && n === '?') break;
      if (c === '?' && n === '>') break;
      if (c === '<' && n === '<' && code[j + 2] === '<') break;
      j++;
    }
    if (j === i) j = i + 1; // güvenlik
    tokens.push({ type: 'code', value: code.slice(i, j) });
    i = j;
  }
  return tokens;
}

/** Bir kod segmentini (string ve yorum dışı) güzelleştirir. */
function beautifyCodeSegment(s) {
  if (!s) return s;

  // Operatörleri korumak için placeholder
  const PH = '\x00';
  const saved = [];
  const COMPOUNDS = [
    '**=', '//=', '<=>', '**', '<<=', '>>=',
    '===', '!==', '==', '!=', '<=', '>=', '&&', '||',
    '??=', '??', '->', '=>', '::', '++', '--',
    '+=', '-=', '*=', '/=', '%=', '.=', '|=', '&=', '^=',
  ];
  // Uzun olandan kısaya doğru placeholder'la
  COMPOUNDS.sort((a, b) => b.length - a.length).forEach((op) => {
    const esc = op.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    s = s.replace(new RegExp(esc, 'g'), () => {
      saved.push(op);
      return `${PH}${saved.length - 1}${PH}`;
    });
  });

  // Virgülden sonra boşluk
  s = s.replace(/,(?! )/g, ', ');
  s = s.replace(/  +,/g, ',');

  // Tekli '=' etrafında boşluk (ama <=> ve >= gibi zaten korunuyor placeholder ile)
  s = s.replace(/([^\s=!<>])=([^\s=])/g, '$1 = $2');

  // '.' birleştirme etrafında boşluk (sayılar hariç)
  s = s.replace(/(\w|\)|\])\.(?![\d.])/g, '$1 . ');
  s = s.replace(/ \. (\S)/g, ' . $1');

  // Kontrol anahtar kelimelerinin önündeki ayraç tutarlılığı
  s = s.replace(PHP_CTRL_KW_RE, (m) => m.replace(/\s+/g, ' '));
  s = s.replace(/\b(if|elseif|while|for|foreach|switch|catch)\s*\(/g, '$1 (');
  s = s.replace(/\)\s*\{/g, ') {');
  s = s.replace(/\}\s*(else|elseif|catch|finally)\b/g, '} $1');

  // Çift boşlukları sadeleştir (satır başı hariç — indent'i formatter yönetiyor)
  s = s.replace(/([^\s]) {2,}/g, '$1 ');

  // Placeholder'ları geri yerleştir
  s = s.replace(new RegExp(`${PH}(\\d+)${PH}`, 'g'), (_, idx) => saved[parseInt(idx, 10)]);

  return s;
}

/** Tek satır kod segmentini, string/yorum sınırlarına dokunmadan beautify eder. */
function beautifyLineTokens(lineTokens) {
  return lineTokens.map((t) => {
    if (t.type === 'code') return { ...t, value: beautifyCodeSegment(t.value) };
    return t;
  });
}

/** Satır bazında bracket dengesini hesaplar — sadece 'code' token'larında sayar. */
function computeBracketDelta(lineTokens) {
  let delta = 0;
  let firstNonWsChar = null;
  let lastNonWsChar = null;
  let fullText = '';
  for (const t of lineTokens) {
    fullText += t.value;
    if (t.type !== 'code') continue;
    for (const ch of t.value) {
      if (ch === '{' || ch === '(' || ch === '[') delta++;
      else if (ch === '}' || ch === ')' || ch === ']') delta--;
    }
  }
  const trimmed = fullText.trim();
  if (trimmed.length > 0) {
    firstNonWsChar = trimmed[0];
    lastNonWsChar = trimmed[trimmed.length - 1];
  }
  return { delta, firstNonWsChar, lastNonWsChar, trimmed };
}

export function formatPhpCode(rawCode) {
  const normalized = rawCode.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const allTokens = tokenizePhp(normalized);

  // Token'ları satırlara böl (comment_block, heredoc gibi multi-line'lar olduğu gibi bir satıra ait)
  // Basit strateji: her '\n' satırı bitirir, ancak çok satırlı token içeren bir satır tek satır gibi
  // davranmalı (formatter ona dokunmaz, olduğu gibi çıktıya yazılır).
  const lines = [];
  let currentLineTokens = [];
  let currentLineBuf = '';

  const flushLine = () => {
    lines.push({ tokens: currentLineTokens, text: currentLineBuf });
    currentLineTokens = [];
    currentLineBuf = '';
  };

  for (const tok of allTokens) {
    // Çok satırlı token (block comment, heredoc, nowdoc) satır bölünmesine dokunulmaz.
    // Ama iç newline'lar satırlara dahil.
    if (tok.value.includes('\n')) {
      const parts = tok.value.split('\n');
      parts.forEach((part, idx) => {
        currentLineTokens.push({ type: tok.type, value: part });
        currentLineBuf += part;
        if (idx < parts.length - 1) flushLine();
      });
    } else {
      currentLineTokens.push(tok);
      currentLineBuf += tok.value;
    }
  }
  if (currentLineBuf.length > 0 || currentLineTokens.length > 0) flushLine();

  const TAB = '    ';
  let indent = 0;
  const out = [];

  for (let li = 0; li < lines.length; li++) {
    const { tokens, text } = lines[li];

    // Bu satırın içeriği çok satırlı bir token'ın gövdesinden mi geliyor?
    // Satırın TÜM token'ları heredoc/nowdoc/comment_block ise indent uygulama.
    const allInsideMulti = tokens.length > 0 && tokens.every((t) =>
      t.type === 'heredoc' || t.type === 'nowdoc' || t.type === 'comment_block'
    );

    if (allInsideMulti) {
      // Orijinal satırı olduğu gibi koru
      out.push(text);
      continue;
    }

    const beautified = beautifyLineTokens(tokens);
    const trimmedText = beautified.map((t) => t.value).join('').trim();

    if (!trimmedText) {
      out.push('');
      continue;
    }

    // Block comment satırlarını koru
    // (tek satırlık /* ... */ beautify'a girmez ama güvende)
    const startsWithClose = /^[}\])]/.test(trimmedText);
    const startsWithCase = /^(case\b|default\s*:)/.test(trimmedText);
    const isPhpCloseTag = /^\?>\s*$/.test(trimmedText);
    const isPhpOpenTag = /^<\?(php|=)?\b/.test(trimmedText);

    if (startsWithClose || startsWithCase || isPhpCloseTag) {
      indent = Math.max(0, indent - 1);
    }

    out.push(TAB.repeat(indent) + trimmedText);

    const { delta } = computeBracketDelta(beautified);
    let newIndent = indent + delta;
    if (startsWithClose) newIndent += 1; // açılışı ön-alandan düştüğümüz için geri ekle
    if (isPhpCloseTag) newIndent += 1;
    if (isPhpOpenTag) {
      // <?php kendi başına satırdaysa indent'i açmadı
    }
    if (startsWithCase && !trimmedText.endsWith('{')) newIndent += 1;

    indent = Math.max(0, newIndent);
  }

  return out.join('\n').replace(/\n{3,}/g, '\n\n');
}

/* ─────────────────────────────────────────────────────────────────────────
   PHP SYNTAX VALIDATOR
   Lightweight lint: Monaco native parser yok PHP için — bu yüzden klasik
   hataları yakalıyoruz. Performans için model'in full text'ini tek geçişte
   tarar.
───────────────────────────────────────────────────────────────────────── */
export function validatePhpCode(code) {
  const diagnostics = [];
  const tokens = tokenizePhp(code);

  // 1) Bracket balance — tüm code segmentlerinde
  const stack = []; // { ch, line, column, idx }
  let line = 1;
  let col = 1;

  const add = (severity, msg, startLine, startCol, endLine = startLine, endCol = startCol + 1) => {
    diagnostics.push({
      severity,
      message: msg,
      startLineNumber: startLine,
      startColumn: startCol,
      endLineNumber: endLine,
      endColumn: endCol,
    });
  };

  // Tokens üzerinde line/col takip ederek yürü
  for (const t of tokens) {
    // Her token için line/col güncellensin
    const updatePos = (str) => {
      for (let k = 0; k < str.length; k++) {
        if (str[k] === '\n') { line++; col = 1; } else { col++; }
      }
    };

    if (t.type === 'string') {
      // Unterminated string tespiti — açılış var ama kapanış yok
      const q = t.value[0];
      const last = t.value[t.value.length - 1];
      const clean = t.value.slice(1, -1).replace(/\\./g, '');
      if (t.value.length < 2 || last !== q || (t.value.length >= 2 && clean.includes('\n') && q === "'")) {
        // Heuristik: tek tırnaklı string newline içeriyorsa PHP'de geçersizdir
        if (q === "'" && clean.includes('\n')) {
          add(8, `Unterminated string or multi-line single-quoted string`, line, col);
        } else if (last !== q) {
          add(8, `Unterminated string literal`, line, col);
        }
      }
      updatePos(t.value);
      continue;
    }

    if (t.type !== 'code') {
      updatePos(t.value);
      continue;
    }

    // Code segmentinde parantez/brace/bracket takibi
    for (let k = 0; k < t.value.length; k++) {
      const ch = t.value[k];
      if (ch === '{' || ch === '(' || ch === '[') {
        stack.push({ ch, line, col });
      } else if (ch === '}' || ch === ')' || ch === ']') {
        const top = stack.pop();
        const expected = { '}': '{', ')': '(', ']': '[' }[ch];
        if (!top) {
          add(8, `Unexpected closing '${ch}' — no matching opener`, line, col);
        } else if (top.ch !== expected) {
          add(8, `Mismatched bracket: expected '${{'{':'}','(':')','[':']'}[top.ch]}' (opened at line ${top.line}:${top.col}), got '${ch}'`, line, col);
        }
      }

      if (ch === '\n') { line++; col = 1; } else { col++; }
    }
  }

  // Dengelenmemiş açık bracket'lar
  while (stack.length > 0) {
    const open = stack.pop();
    add(8, `Unclosed '${open.ch}' — opened here and never closed`, open.line, open.col);
  }

  // 2) PHP açılış tag'i kontrolü
  const first200 = code.slice(0, 200);
  if (code.length > 0 && !first200.match(/<\?(php|=)?/)) {
    // Çok katı değil — PHP script başlıklarında yoksa sadece uyar
    add(4, 'PHP dosyası genelde `<?php` ile başlamalıdır', 1, 1);
  }

  return diagnostics;
}

/* ── Monaco editor varsayılan seçenekleri ── */
export const EDITOR_BASE_OPTIONS = {
  fontSize: 13,
  lineHeight: 21,
  fontFamily: "'Cascadia Code', 'Fira Code', 'JetBrains Mono', Consolas, 'Courier New', monospace",
  fontLigatures: true,
  minimap: { enabled: true, scale: 1, renderCharacters: false },
  wordWrap: 'on',
  automaticLayout: true,
  scrollBeyondLastLine: false,
  scrollBeyondLastColumn: 5,
  padding: { top: 12, bottom: 12 },
  lineNumbers: 'on',
  lineNumbersMinChars: 4,
  glyphMargin: false,
  folding: true,
  renderLineHighlight: 'gutter',
  renderWhitespace: 'none',
  matchBrackets: 'always',
  roundedSelection: true,
  selectionHighlight: true,
  occurrencesHighlight: 'singleFile',
  cursorBlinking: 'smooth',
  cursorStyle: 'line',
  cursorWidth: 2,
  // Çok yavaş wheel/trackpad hareketlerinde delta kaybını azalt
  // (smooth interpolation küçük delta'ları "yutar" gibi hissettirebiliyor)
  smoothScrolling: false,
  inertialScroll: false,
  mouseWheelScrollSensitivity: 2.2,
  fastScrollSensitivity: 4,
  scrollPredominantAxis: false,
  // Özellikle uzun satırlarda wrapping hesap yükünü azaltır
  wrappingStrategy: 'simple',
  // Monaco'nun render pipeline'ını GPU tarafına taşıyarak scroll akıcılığını artırır
  experimentalGpuAcceleration: 'on',
  mouseWheelZoom: true,
  // PERFORMANS: Suggestion tetiklenmesini yavaşlatarak typing'de CPU spike'larını düşür.
  quickSuggestions: { other: true, comments: false, strings: false },
  quickSuggestionsDelay: 150,
  suggestOnTriggerCharacters: true,
  acceptSuggestionOnEnter: 'on',
  acceptSuggestionOnCommitCharacter: true,
  tabCompletion: 'on',
  wordBasedSuggestions: 'currentDocument',
  suggest: {
    showKeywords: true, showSnippets: true, showFunctions: true,
    showVariables: true, showClasses: true, showMethods: true, showProperties: true,
    showConstants: true, showValues: true, showWords: true,
    insertMode: 'replace', filterGraceful: true, localityBonus: true,
    shareSuggestSelections: true, preview: false,
  },
  inlineSuggest: { enabled: false },
  parameterHints: { enabled: true, cycle: true },
  hover: { enabled: true, delay: 500 },
  'semanticHighlighting.enabled': false,
  tabSize: 4,
  insertSpaces: true,
  formatOnPaste: true,
  formatOnType: false,
  autoIndent: 'full',
  trimAutoWhitespace: true,
  dragAndDrop: true,
  links: true,
  contextmenu: true,
  overviewRulerLanes: 0,
  hideCursorInOverviewRuler: true,
  overviewRulerBorder: false,
  scrollbar: {
    vertical: 'auto', horizontal: 'auto',
    verticalScrollbarSize: 8, horizontalScrollbarSize: 8,
    useShadows: false,
    // Scroll editör sınırına gelince wheel event'i page'e devret (blocking olmaz)
    alwaysConsumeMouseWheel: false,
  },
  // PERFORMANS: Focus dışında line highlight render etme — gereksiz GPU paint azaltır
  renderLineHighlightOnlyWhenFocus: true,
  // PERFORMANS: Layer ipuçlarını kapat → GPU compositor daha az layer yönetir
  disableLayerHinting: true,
  // Sticky scroll kapalı (scroll performansı için).
  // Bracket pair colorization AÇIK (scope'ları renkle ayırır) — ama rehber çizgileri KAPALI.
  stickyScroll: { enabled: false },
  bracketPairColorization: { enabled: true, independentColorPoolPerBracketType: true },
  guides: {
    bracketPairs: false,
    bracketPairsHorizontal: false,
    highlightActiveBracketPair: true,   // sadece cursor etrafındaki bracket vurgulansın
    indentation: false,                 // dikey indent çizgileri yok
    highlightActiveIndentation: false,
  },
};
